import React, { useState, useEffect } from "react";
import axios from "axios";
import DataTable from "../../Student/Reusablecomponents/DataTable/DataTable";
import Loading from "../../Student/Reusablecomponents/Loading";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";

const ReviewQuestions = () => {

//   const navigate = useNavigate();
  const location = useLocation();

  const items = useSelector((state) => state.userDetailsData.LoginDetails);
    const [Hindi,SetHindi] = useState();
    const [Load, SetLoad] = useState(false);
useEffect(() => {
    GetHindiVerification();

  }, [location.state?.Tab]);
    const HindiColumns = [
        { name: "Total Questions", selector: "totalQuestions", sortable: true, cell: row => (<div className={row.totalQuestions && "LinkStyles"} /*onClick={() => { row.totalQuestions && NVerifyStatus(0, row.createdBy) }}*/ >{HindiCount(row)} </div>), },
        { name: "Authoring", selector: "authoring", sortable: true, cell: row => (<div className={row.authoring && "LinkStyles"} /* onClick={() => { row.authoring && NVerifyStatus(QVCode.find((item) => item.lovDescription === "Authoring")?.lovId, row.createdBy) }}*/ >{row.authoring} </div>), },
        { name: "Verify", selector: "verify", sortable: true, cell: row => (<div className={row.verify && "LinkStyles"} /*onClick={() => { row.verify && NVerifyStatus(QVCode.find((item) => item.lovDescription === "Verify")?.lovId, row.createdBy) }}*/ >{row.verify} </div>), },
        { name: "Correction", selector: "correction", sortable: true, cell: row => (<div className={row.correction && "LinkStyles"} /*onClick={() => { row.correction && NVerifyStatus(QVCode.find((item) => item.lovDescription === "Correction")?.lovId, row.createdBy) }}*/ >{row.correction} </div>), },
        { name: "Re-Verify", selector: "reVerify", sortable: true, cell: row => (<div className={row.reVerify && "LinkStyles"} /*onClick={() => { row.reVerify && NVerifyStatus(QVCode.find((item) => item.lovDescription === "Re-verify")?.lovId, row.createdBy) }} */>{row.reVerify} </div>), },
        { name: "Completed", selector: "completed", sortable: true, cell: row => (<div className={row.completed && "LinkStyles"} /*onClick={() => { row.completed && NVerifyStatus(QVCode.find((item) => item.lovDescription === "Completed")?.lovId, row.createdBy) }}*/ >{row.completed} </div>), },
    ];
    const HindiCount = (row) => {
        return (
            (row.authoring || 0) +
            (row.verify || 0) +
            (row.correction || 0) +
            (row.reVerify || 0) +
            (row.completed || 0)
        );
    }

    const GetHindiVerification = async () => {
        SetLoad((prev) => !prev);
        await axios.get(process.env.REACT_APP_API_BASE_URL + `/QuestionBank/GetHindiQCountsByQStatus?QBCategoryCode=${location.state?.Tab}&SubjectId=${items?.subjectId}`, { headers: { XApiKey: process.env.REACT_APP_XApiKey } })
            .then((res) => {
                SetHindi(res.data);
                SetLoad((prev) => !prev);
            })
            .catch((err) => { console.log(err); });
    };
    return (
        <>
            <div className="Card mt-2">
                {Hindi ?
                    <DataTable
                        data={Hindi}
                        columns={HindiColumns}
                        Dropdownvalues={["10", "15", "20"]}
                        className="NCLDataTable"
                        ShowPagination="true" ShowPagecount="true" />
                    :
                    <div className="NoData-Message"> {process.env.REACT_APP_Nodata_Found} </div>
                }
            </div>

            {Load && <Loading />}
        </>
    )
}
export default ReviewQuestions;